import { NavTarget } from '../../components/link/link.component';
import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { NgTemplateOutlet, PlatformLocation } from '@angular/common';
import { KompaktdarstellungTemplateComponent } from '../kompakt-darstellung-template.component';
import { ComponentLocationStrategy } from '../../services/location-strategy/component-location-strategy';
import { FormatConfigService } from '../../../core/services/format-config.service';
import { AmtlicheBewertungDetailEntryMeta } from 'app/core/amtlichebewertung-api';
import { TranslatePipe } from '@ngx-translate/core';
import { BetragPipe } from '../../pipes/simple/betrag.pipe';
import { DatumPipe } from '../../pipes/simple/datum.pipe';
import { DatumZeitPipe } from '../../pipes/simple/datumZeit.pipe';

@Component({
  selector: 'cap-kompakt-amtliche-bewertung',
  templateUrl: './kompakt-amtliche-bewertung.component.html',
  preserveWhitespaces: false,
  imports: [NgTemplateOutlet, TranslatePipe, BetragPipe, DatumPipe, DatumZeitPipe]
})
export class KompaktAmtlicheBewertungComponent extends KompaktdarstellungTemplateComponent implements OnInit {
  @Input()
  amtlicheBewertung: AmtlicheBewertungDetailEntryMeta;

  @ViewChild('typ00', { static: true }) typ00Template: TemplateRef<any>;
  @ViewChild('typ01', { static: true }) typ01Template: TemplateRef<any>;
  @ViewChild('typ02', { static: true }) typ02Template: TemplateRef<any>;
  @ViewChild('typ03', { static: true }) typ03Template: TemplateRef<any>;

  text = '';

  navTargets = NavTarget;

  constructor(
    formatService: FormatConfigService,
    location: PlatformLocation,
    locationStrategy: ComponentLocationStrategy,
    protected appformatConfigService: FormatConfigService
  ) {
    super(formatService, 'AMTLICHE_BEWERTUNG', location, locationStrategy);
    keysToTranslate<string>([
      'Nein',
      'Ja',
      'Gültig',
      'Protokollnummer',
      'vom',
      '(mit Ertragswertkomponente)',
      'AW',
      'EW',
      'Grundgueterschaetzung',
      'Gebaeudeschatzung',
      'gültigAbSteuerjahr',
      'aktualisierungsdatum'
    ]);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  registerTemplates() {
    this.bindTemplates(this.typ00Template, 'AMTLICHE_BEWERTUNG_TYP00');
    this.bindTemplates(this.typ01Template, 'AMTLICHE_BEWERTUNG_TYP01');
    this.bindTemplates(this.typ02Template, 'AMTLICHE_BEWERTUNG_TYP02');
    this.bindTemplates(this.typ03Template, 'AMTLICHE_BEWERTUNG_TYP03');
  }

  getDefaultTemplate(): TemplateRef<any> {
    return this.typ00Template;
  }
}
